module.exports = __webpack_public_path__ + "static/media/icon-sepa.baa70b5c.svg";